module.exports = __webpack_public_path__ + "static/3-68c56d769d41c7d694fe47902feb1948.jpg";